import { DiscussionContentItem } from '@front-app/services/GroupsApi/DiscussionModel';
import { isNullish } from '@front-app/util/types';
import { SurveyProvider } from '@front-app/modules/group/highlights/model';

export const isRemovedDiscussion = (item: DiscussionContentItem) => {
	// eslint-disable-next-line
	for (let message of item.metadata.discussion.messages) {
		if (!message.removedAt) {
			return false;
		}
	}
	return true;
};

export const divElementFromHtmlText = (htmlText: string): HTMLElement => {
	const div = document.createElement('div');
	div.innerHTML = htmlText;
	return div;
};

export const htmlToText = (htmlText: string, maxLen?: number): string => {
	const div = divElementFromHtmlText(htmlText);
	const textVal = (div.textContent || div.innerText).trim();
	if (isNullish(maxLen)) {
		return textVal;
	}
	return textVal.substr(0, maxLen);
};

export const extractSurveyIdFromUrl = (urlAsString: string): string => {
	const url = new URL(urlAsString);
	const urlParts = url.pathname.split('/');
	return urlParts[urlParts.length - 1];
}

export const extractIdFromSurveyEmbedCode = (embedCode: string, type: SurveyProvider): string => {
	const container = document.createElement('div');
	container.innerHTML = embedCode;
	const script = container.querySelector('script');
	if (!script) {
		return '';
	}

	return extractSurveyIdFromUrl(script.src);
}

export const convertSurveyIdToUrl = (id: string, type: SurveyProvider): string => {
	switch (type) {
	case SurveyProvider.JOTFORM:
		return `https://form.jotform.com/${id}`;
	case SurveyProvider.SURVEY_MONKEY:
		return `https://www.surveymonkey.com/r/${id}`;
	default:
		return '';
	}
}
